import { List } from "@material-ui/core";
import { MenuItem } from "../MenuItem";
import PostAddIcon from '@material-ui/icons/PostAdd';
import ListIcon from '@material-ui/icons/List';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import BallotIcon from '@material-ui/icons/Ballot';
import DnsIcon from '@material-ui/icons/Dns';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn'
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
// import ViewListIcon from '@material-ui/icons/ViewList';
import TuneIcon from '@material-ui/icons/Tune';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import { Role } from "../../enum/roles.enum";
import { Modules } from "../../enum/modules.enum";

interface MenuProps {
    userType: string;
    modules: Array<string>; 
    expanded: string;
    onClick:(item: string) => void;
}

const getMenuItems = (userType: string, modules: string[]) => {
  const routes = [
    { id: Modules.DASHBOARD, text: 'Dashboard', icon: <DashboardIcon />, to: '/dashboard' },
    { id: Modules.LICENCA, text: 'Licenças', icon: <AssignmentIcon />, to: '/licencas' },
    { id: Modules.REQUISICAO, text: 'Requisição Eletrônica', icon: <ListAltIcon />, to: '/', submenu: [
      {
        to: '/requisicao/emissao',
        icon: <PostAddIcon />,
        text: 'Emitir Requisição',
      },
      {
        to: '/requisicao/emissao/consulta',
        icon: <ListIcon />,
        text: 'Consulta Emissão',
      }, {
        to: '/requisicao/aprovacao',
        icon: <PlaylistAddIcon />,
        text: 'Aprovação Requisição',
      },
      {
        to: '/requisicao/aprovacao/consulta',
        icon: <ListIcon />,
        text: 'Consulta Aprovação',
      },
    ]},
    // { id: Modules.REQUISICAOAPROVACAO, text: 'Aprovação Requisição Eletrônica', icon: <ViewListIcon />, to: '/', submenu: []},
    { id: Modules.APROVACAO, text: 'Ordem de Compra', icon: <BallotIcon />, to: '/', submenu: [
      {
        to: '/ordemcompra/emissao',
        icon: <PostAddIcon />,
        text: 'Emitir O.C',
      },
      {
        to: '/ordemcompra/emissao/consulta',
        icon: <ListIcon />,
        text: 'Consulta O.C.',
      },
      {
        to: '/ordemcompra/aprovacao',
        icon: <PostAddIcon />,
        text: 'Aprovação O.C.',
      },
      {
        to: '/ordemcompra/aprovacao/consulta',
        icon: <ListIcon />,
        text: 'Consulta Aprovação',
      },
    ]},
    { id: Modules.MANUTENCAO, text: 'Manutenção', icon: <DnsIcon />, to: '/', submenu: [
      {
        to: '/manutencao/solicitar',
        icon: <AssignmentIcon />,
        text: 'Solicitar Manutenção',
      },
      {
        to: '/manutencao/solicitar/consulta',
        icon: <ListIcon />,
        text: 'Consulta Solicitar Manutenção',
      },
      {
        to: '/manutencao/apontar',
        icon: <AssignmentReturnIcon />,
        text: 'Apontar Manutenção',
      },
      {
        to: '/manutencao/apontar/consulta',
        icon: <ListIcon />,
        text: 'Consulta Apontamento Manutenção',
      },
      {
        to: '/manutencao/coleta',
        icon: <AssignmentReturnedIcon />,
        text: 'Apontar Coleta',
      },
      {
        to: '/manutencao/coleta/consulta',
        icon: <ListIcon />,
        text: 'Consulta Apontamento Coleta',
      },
      {
        to: '/manutencao/painel',
        icon: <TuneIcon />,
        text: 'Painel',
      },
      {
        to: '/manutencao/dashboard',
        icon: <DashboardIcon />,
        text: 'Dashboard Manutenção',
      },
    ]},
    {
      id: Modules.SOLICITACAOCOMPRA, text: 'Solicitação de Compra', icon: <AssignmentIcon />, to: '/solicitacao-compra/emissao'
    },
    {
      id: Modules.COTACOES, text: 'Cotações', icon: <ReceiptOutlinedIcon />, to: '/', submenu: [
        {
          to: '/cotacao/aprovacao',
          icon: <LowPriorityIcon />,
          text: 'Aprovar Cotação',
        },
        {
          to: '/cotacao/aprovacao/consulta',
          icon: <ListIcon />,
          text: 'Consulta Aprovação Cotação',
        },
      ],
    }
  ]
  if (userType === Role.ADMIN || userType === Role.QUATTUOR) {
    return routes.map(route => {
      // Caso especial para o módulo APROVACAO (Ordem de Compra)
      if (route.id === Modules.APROVACAO) {
        const hasAprovacao = modules.includes(Modules.APROVACAO);
        const hasOrdemCompra = modules.includes(Modules.ORDEMCOMPRA);

        if (!hasAprovacao && !hasOrdemCompra) return null;

        // Clona o route com submenu filtrado
        const filteredSubmenu = route.submenu?.filter((item, index) => {
          // Index 0 e 1: OrdemCompra
          if (hasOrdemCompra && index <= 1) return true;
          // Index 2 e 3: Aprovação
          if (hasAprovacao && index >= 2) return true;
          return false;
        });

        return {
          ...route,
          submenu: filteredSubmenu,
        };
      }

      // Para outros módulos, retorna apenas se estiver no array de módulos
      if (modules.includes(route.id)) return route;

      return null;
    })
    .filter((route) => route !== null && route !== undefined);
  } else if (userType === Role.VENDEDOR) {
    return routes
      .map(route => {
      // Caso especial para o módulo APROVACAO (Ordem de Compra)
      if (route.id === Modules.APROVACAO) {
        const hasAprovacao = modules.includes(Modules.APROVACAO);
        const hasOrdemCompra = modules.includes(Modules.ORDEMCOMPRA);

        if (!hasAprovacao && !hasOrdemCompra) return null;

        // Clona o route com submenu filtrado
        const filteredSubmenu = route.submenu?.filter((item, index) => {
          // Index 0 e 1: OrdemCompra
          if (hasOrdemCompra && index <= 1) return true;
          // Index 2 e 3: Aprovação
          if (hasAprovacao && index >= 2) return true;
          return false;
        });

        return {
          ...route,
          submenu: filteredSubmenu,
        };
      }

      if (route.id === Modules.LICENCA ) return null;

      // Para outros módulos, retorna apenas se estiver no array de módulos
      if (modules.includes(route.id)) return route;

      return null;
    })
    .filter((route) => route !== null && route !== undefined);
  } else {
    return [];
  }
};

export const Menu: React.FC<MenuProps> = ({ userType, modules, expanded, onClick }) => {
  const menuItems = getMenuItems(userType, modules)

  return (
    <List>
      {menuItems.map((item) => {
        if(item === null || item === undefined) return null;
        
        if (item.submenu) {
          return (
            <MenuItem
              key={item.text}
              to={item.to}
              icon={item.icon}
              text={item.text}
              expanded={expanded}
              onClick={onClick}
              submenu={item.submenu.map((subitem:any) => (
                <MenuItem
                  key={subitem.text}
                  to={subitem.to}
                  icon={subitem.icon}
                  text={subitem.text}
                  expanded={expanded}
                  onClick={onClick}
                />
              ))}
            />
          )
        } else {
          return (
            <MenuItem
                key={item.text}
                to={item.to}
                icon={item.icon}
                text={item.text} 
                expanded={expanded}
                onClick={onClick}
            />
          )
        }
      }
      )}
    </List>
  );
};